module.exports = __webpack_public_path__ + "static/img/02.60608329.png";